import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M4 7l16 0","key":"svg-0"}],["path",{"d":"M4 17l16 0","key":"svg-1"}],["path",{"d":"M7 4l0 16","key":"svg-2"}],["path",{"d":"M17 4l0 16","key":"svg-3"}]]

/**
 * IconFrame
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItZnJhbWUiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTQgN2wxNiAwIiAvPgogIDxwYXRoIGQ9Ik00IDE3bDE2IDAiIC8+CiAgPHBhdGggZD0iTTcgNGwwIDE2IiAvPgogIDxwYXRoIGQ9Ik0xNyA0bDAgMTYiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/frame
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconFrame = createReactComponent('outline', 'frame', 'Frame', __iconNode);

export default IconFrame;